import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TargetFileFormingResultStatus } from '../../enums/target-file-forming-result-status.enum';
import { TargetFileFormingResultAppearedEventData } from '../contracts/targetFileFormingResultAppearedEventData';
import { ToastEnum } from '../../enums/toast.enum';
import { DownloadArchiveService } from '../../services/download-archive.service';

@Injectable({
  providedIn: 'root',
})
export class TargetFileFormingResultAppearedEventHandler {
  constructor(
    private _messageService: MessageService,
    private _downloadArchiveService: DownloadArchiveService
  ) {}
  public async handle(message: TargetFileFormingResultAppearedEventData): Promise<void> {
    this._downloadArchiveService.isFormingArchive.next(false);
    switch (TargetFileFormingResultStatus[message.result]) {
      case TargetFileFormingResultStatus.Success: {
        this._messageService.add({
          sticky: true,
          summary: 'Завершено формирование архива ',
          detail: '',
          data: { ...message, typeEnum: ToastEnum.archiveToast },
        });
        break;
      }
      case TargetFileFormingResultStatus.PartiallyGenerated: {
        this._messageService.add({
          sticky: true,
          summary: 'Завершено формирование архива ',
          detail: '. К сожалению, не удалось загрузить часть запрошенных файлов.',
          data: { ...message, typeEnum: ToastEnum.archiveToast },
        });
        break;
      }
      case TargetFileFormingResultStatus.Failure: {
        this._messageService.add({
          severity: 'error',
          sticky: false,
          life: 30000,
          summary: 'При формировании архива ',
          detail: ' возникла непредвиденная ошибка',
          data: { ...message, typeEnum: ToastEnum.errorToast },
        });
        break;
      }
      case TargetFileFormingResultStatus.NoFiles: {
        this._messageService.add({
          severity: 'warn',
          sticky: false,
          life: 30000,
          summary: 'Невозможно сформировать архив ',
          detail: '. Отсутствуют документы для формирования архива.',
          data: { ...message, typeEnum: ToastEnum.warnToast },
        });
        break;
      }
    }
  }
}
